import React, { useMemo } from 'react';
import { parseDate, renderDate } from '../../utils/dateUtils';
import { IconCalendar } from '../common/Icons';

const Timeline = ({ events }) => {
    const sortedEvents = useMemo(() => {
        return events
            .filter(e => parseDate(e.Date) !== null)
            .sort((a, b) => parseDate(a.Date) - parseDate(b.Date));
    }, [events]);

    const eventsByMonth = useMemo(() => {
        return sortedEvents.reduce((acc, event) => {
            const date = parseDate(event.Date);
            const monthYear = date.toLocaleDateString('th-TH', { month: 'long', year: 'numeric' });
            if (!acc[monthYear]) {
                acc[monthYear] = [];
            }
            acc[monthYear].push(event);
            return acc;
        }, {});
    }, [sortedEvents]);

    const currentMonthYear = new Date().toLocaleDateString('th-TH', { month: 'long', year: 'numeric' });

    return (
        <div className="mt-12">
            <h2 className="text-2xl font-bold text-gray-800 text-center mb-8">Timeline การแข่งขัน</h2>
            <div className="relative border-l-2 border-blue-500 ml-6">
                {Object.entries(eventsByMonth).map(([monthYear, monthEvents]) => {
                    const isCurrentMonth = monthYear === currentMonthYear;
                    return (
                        <div key={monthYear} className="mb-8">
                            <div className={`absolute -left-4 w-8 h-8 ${isCurrentMonth ? 'bg-green-500' : 'bg-blue-500'} rounded-full text-white flex items-center justify-center font-bold`}>
                                <IconCalendar width={16} height={16} />
                            </div>
                            <div className="ml-10">
                                <h3 className={`text-xl font-semibold ${isCurrentMonth ? 'text-green-600' : 'text-blue-600'} -mt-1`}>{monthYear}</h3>
                                <div className="mt-4 space-y-4">
                                    {monthEvents.map((event, index) => (
                                        <div key={`timeline-${event.ID}-${index}`} className="bg-white p-4 rounded-lg shadow-md border-l-4 border-blue-300">
                                            <p className="font-bold text-gray-800">{event.Event}</p>
                                            <p className="text-sm text-gray-600">{renderDate(event.Date, { day: 'numeric', month: 'long', year: 'numeric' })}</p>
                                            <p className="text-sm text-gray-500">{event.Location}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Timeline;
